type PaymentOpsLookup = 'payment-intents' | 'provider-events' | 'webhook-events';

function buildPaymentOpsUrl(params: Record<string, string | null | undefined>, lookup: PaymentOpsLookup = 'payment-intents'): string {
  const searchParams = new URLSearchParams();
  if (lookup !== 'payment-intents') {
    searchParams.set('lookup', lookup);
  }

  Object.entries(params).forEach(([key, value]) => {
    if (value && value.trim()) {
      searchParams.set(key, value.trim());
    }
  });

  const query = searchParams.toString();
  return query ? `/admin/payment-ops?${query}` : '/admin/payment-ops';
}

export function paymentOpsByTripGroupUrl(tripGroupId: string | null | undefined): string {
  return buildPaymentOpsUrl({ tripGroupId });
}

export function paymentOpsByPrimaryBookingUrl(primaryBookingId: string | null | undefined): string {
  return buildPaymentOpsUrl({ primaryBookingId });
}

export function paymentOpsByProviderIntentUrl(providerIntentId: string | null | undefined): string {
  return buildPaymentOpsUrl({ providerIntentId });
}

export function providerEventsByReferenceUrl(
  provider: string | null | undefined,
  providerReference: string | null | undefined,
): string {
  return buildPaymentOpsUrl({ provider, providerReference }, 'provider-events');
}
